import React from "react";
import {useParams} from "react-router";

import {IRankingAnnualParams} from "@pg-mono/rp-routes";

import {OfferRanking} from "../components/offer_ranking/OfferRanking";
import {Ranking2022} from "../components/ranking_2022/Ranking2022";

export const RankingAnnualView = () => {
    const params = useParams<IRankingAnnualParams>();

    if (!params.year) {
        return <OfferRanking />;
    }

    return <Ranking2022 />;
};
import React from "react";
import {useParams} from "react-router";

import {IRankingAnnualParams} from "@pg-mono/rp-routes";

import {OfferRanking} from "../components/offer_ranking/OfferRanking";
import {Ranking2022} from "../components/ranking_2022/Ranking2022";

export const RankingAnnualView = () => {
    const params = useParams<IRankingAnnualParams>();

    if (!params.year) {
        return <OfferRanking />;
    }

    return <Ranking2022 />;
};
